import { render, staticRenderFns } from "./AgeVerificationModal.vue?vue&type=template&id=2e89f1f6&scoped=true&"
import script from "./AgeVerificationModal.vue?vue&type=script&lang=js&"
export * from "./AgeVerificationModal.vue?vue&type=script&lang=js&"
import style0 from "./AgeVerificationModal.vue?vue&type=style&index=0&id=2e89f1f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e89f1f6",
  null
  
)

export default component.exports